export default __webpack_public_path__ + "static/media/01.57afffc1.jpg";